import React from "react";
import { Redirect } from "react-router-dom";

const withRestriction =
  ({ component, roles, accountType }) =>
  () => {
    const session = localStorage.getItem("session");
    const sessionObj = session && JSON.parse(session);
    const loggedInUser = localStorage.getItem("loggedInUser");
    const loggedInUserObj = loggedInUser && JSON.parse(loggedInUser);

    if (!sessionObj) {
      localStorage.removeItem("session");
      return <Redirect to="/login" />;
    }

    if (
      loggedInUserObj &&
      roles &&
      roles.indexOf(loggedInUserObj.role) === -1
    ) {
      // role not authorized so redirect to setup page
      return <Redirect to={{ pathname: "/" }} />;
    }

    if (
      loggedInUserObj &&
      accountType &&
      accountType.indexOf(loggedInUserObj.accountType) === -1
    ) {
      // accountType not authorized so redirect to setup page
      return <Redirect to={{ pathname: "/" }} />;
    }

    return component;
  };

export default withRestriction;
